import * as React from 'react'
import { useState } from 'react'
import { DrawerWrapper } from '@/components'
import { ElectricityMixUsageDrawer } from '../ElectricityMixUsageDrawer/ElectricityMixUsageDrawer'
import useSustainabilityStore from '../../stores/useSustainabilityStore/useSustainabilityStore'
import { useSustainabilityFiltersStore } from '../../hooks/useSustainabilityFiltersStore'
import { useElementWidth } from '@/hooks'
import { useFiltersStore } from '@/hooks'
import { mapFiltersToParams } from '@/features/Reporting/components/ReportEdit/mapFiltersToParams'
import { useSustainabilityHeaderSlot } from '../SustainabilityHeaderSlot/useSustainabilityHeaderSlot'
import { TotalEmissionsReport } from '../TotalEmissions/TotalEmissionsReport'
import { ElectricityMixUsageActions } from './ElectricityMixUsageActions/ElectricityMixUsageActions'
import { useSustainabilityFiltersGetParams } from '../../hooks/useSustainabilityFiltersGetParams'
import { useScope2TypeAvailability } from '../../hooks/useScope2TypeAvailability'
import { useFeatureFlag } from '@/components/providers/FeatureFlagsProvider/useFeatureFlag'

export const ElectricityMixUsage: React.FC = () => {
    const { setSlot } = useSustainabilityHeaderSlot()
    const [isOpen, setIsOpen] = useState(false)
    const toggleButtonRef = React.useRef<HTMLButtonElement>(null)
    const toggleWidth = useElementWidth(toggleButtonRef)

    const isDataManagementEnabled = useFeatureFlag('dataManagement')

    const activeFilters = useSustainabilityFiltersStore(
        (state) => state.activeFilters
    )
    const rootNode = useFiltersStore((state) => state.rootNode)

    const filterParams = mapFiltersToParams(activeFilters)

    if (filterParams.nodeIds.length === 0 && rootNode?.nodeId !== undefined) {
        filterParams.nodeIds = [rootNode.nodeId]
    }

    const reportSettings = useSustainabilityStore(
        (state) => state.electricityMix.reportSettings
    )

    const setReportSettings = useSustainabilityStore(
        (state) => state.electricityMix.setReportSettings
    )

    const { isMarketBasedScope2Available, isFetched } =
        useScope2TypeAvailability({
            reportSettings,
            setReportSettings,
        })

    const view = useSustainabilityStore(
        (state) => state.electricityMix.selectedView
    )

    const setView = useSustainabilityStore(
        (state) => state.electricityMix.setSelectedView
    )

    const calculationMethodOffset = isOpen ? 16 : toggleWidth

    const processedFilters = useSustainabilityFiltersGetParams(
        activeFilters,
        reportSettings
    )

    React.useEffect(() => {
        setSlot(<ElectricityMixUsageActions filters={processedFilters} />)
        return () => {
            setSlot(null)
        }
    }, [processedFilters, setSlot])

    return (
        <DrawerWrapper>
            <ElectricityMixUsageDrawer
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                toggleButtonRef={toggleButtonRef}
                reportSettings={reportSettings}
                setReportSettings={setReportSettings}
                isMarketBasedScope2Available={isMarketBasedScope2Available}
                isDataReady={!isDataManagementEnabled || isFetched}
            />
            <TotalEmissionsReport
                filters={activeFilters}
                reportSettings={reportSettings}
                isOpen={isOpen}
                calculationMethodOffset={calculationMethodOffset}
                view={view}
                setView={setView}
            />
        </DrawerWrapper>
    )
}
